document.addEventListener("DOMContentLoaded", function() {
  // Aggiungi un gestore di eventi click a tutti i bottoni sibling-button
  document.querySelectorAll('.variations--siblings [id^="sibling-button-"]').forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault(); // Evita il comportamento predefinito del link
      console.log("Button clicked:", button); // Debug: Verifica se l'evento click è stato attivato
      var selectedSize = getSelectedSize(); // Ottieni la taglia attualmente selezionata
      console.log("Selected Size:", selectedSize);

      if (selectedSize) {
        var variantsData = button.getAttribute('data-variants'); // Ottieni i dati delle varianti associate al pulsante
        console.log("Variants Data:", variantsData);

        // Cerca il valore della taglia uguale a quella attualmente selezionata
        var variantId = findVariantId(variantsData, selectedSize);
        console.log("Variant ID:", variantId);

        if (variantId) {
          // Aggiungi il parametro variant con l'id della variante al link del bottone
          var url = button.getAttribute('href');
          console.log("Original URL:", url);

          // Verifica se l'URL contiene già un parametro "?"
          if (url.includes('?')) {
            // Sostituisci il valore del parametro "variant" con quello nuovo
            var regex = new RegExp('([?&])variant=.*?(&|$)', 'i');
            url = url.replace(regex, '$1variant=' + variantId + '$2');
          } else {
            // Aggiungi il parametro "variant" all'URL
            url += '?variant=' + variantId;
          }
          console.log("Updated URL:", url);

          // Reindirizza alla nuova pagina
          window.location.href = url;
        } else {
          // Aggiungi il parametro variant con l'id della variante al link del bottone
          var url = button.getAttribute('href');
          console.log("Original URL:", url);

          // Verifica se l'URL contiene già un parametro "?"
          if (url.includes('?')) {
            // Sostituisci il valore del parametro "variant" con quello nuovo
            var regex = new RegExp('([?&])variant=.*?(&|$)', 'i');
            url = url.replace(regex, '$1variant=' + variantId + '$2');
          } else {
            // Aggiungi il parametro "variant" all'URL
            url = url
          }
          console.log("Updated URL:", url);

          // Reindirizza alla nuova pagina
          window.location.href = url;
        }
      }
    });
  });

  // Funzione per ottenere la taglia attualmente selezionata
  function getSelectedSize() {
    
    var selectedSizeElement = document.querySelector('.product-form__input input[type="radio"]:checked');
    if (selectedSizeElement) {
      return selectedSizeElement.value;
    }
    return null;
  }
  
  // Funzione per trovare l'id della variante corrispondente alla taglia selezionata
  function findVariantId(variantsData, selectedSize) {
    var variants = variantsData.split(','); // Dividi i dati delle varianti utilizzando la virgola come separatore
    for (var i = 0; i < variants.length; i++) {
      var pair = variants[i].split(':'); // Dividi ogni coppia taglia:id
      var variantSize = pair[0].trim(); // Taglia della variante
      console.log("Selected size:", selectedSize.trim(), "Variant size:", variantSize);
      if (variantSize === selectedSize.trim()) { // Confronta la taglia selezionata con la taglia della variante
        return pair[1]; // L'id della variante è nella seconda parte della coppia
      }
    }
    return null; // Restituisce null se non viene trovata nessuna corrispondenza
  }
});
